import { types } from "mobx-state-tree"

export const CounterStore = types
  .model("CounterStore", {
    count: types.optional(types.number, 0),
  })
  .actions((self) => ({
    increment() {
      self.count += 1
    },
    decrement() {
      self.count -= 1
    },
    reset() {
      self.count = 0
    },
  }))
  .views((self) => ({
    get isPositive() {
      return self.count > 0
    },
    get isNegative() {
      return self.count < 0
    },
  }))

export type CounterStoreType = typeof CounterStore.Type
